"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FormInputPhoneNumberStyle = {
    baseStyle: {
        group: {
            width: 'auto',
        },
        leftElement: {
            cursor: 'pointer',
            width: '96px',
            borderRight: '1px solid',
            borderColor: 'gray.400',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            paddingLeft: '10px',
            paddingRight: '3px',
        },
        dialCode: {
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '24px',
            marginLeft: '8px',
            marginRight: 'auto',
        },
        input: {
            paddingLeft: '108px',
            fontSize: '16px',
            borderColor: 'gray.400',
            _invalid: {
                borderColor: 'red.400',
            },
            _focus: {
                borderColor: 'notification.blue',
            },
        },
        error: {
            color: 'red.400',
            fontWeight: '400',
        },
        searchOnListBox: {
            maxH: 'xs',
            bg: 'white',
            width: '195px',
            zIndex: '999',
            height: 'auto',
            overflow: 'auto',
            borderRadius: 'lg',
            position: 'absolute',
            boxShadow: '0px 1px 30px rgba(0, 0, 0, 0.1)',
        },
        searchOnListListItem: {
            padding: '3',
            height: '40px',
            width: '193px',
            fontSize: '16px',
            fontWeight: '400',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            _hover: {
                backgroundColor: 'lilac.50',
            },
        },
        label: {},
    },
};
exports.default = FormInputPhoneNumberStyle;
